import { AxiosError } from "axios"
import { get } from "react-hook-form"
import { Subscription_Status, UserSchoolPlan } from "ts/enums/User"
import { IUserMe, IUserTeacher } from "ts/interfaces/User"

export const getErrorMessage = (error: AxiosError) => {
  const errorDetail = get(error, "response.data.detail", null)
  return typeof errorDetail === "string"
    ? errorDetail
    : "validations.anErrorOccured"
}

export const isCleverRestrictedError = (error: AxiosError): boolean => {
  const allowedMethods = get(error, "response.data.allowed_methods", null)
  return (
    error.response?.status === 403 &&
    Array.isArray(allowedMethods) &&
    allowedMethods.includes("clever")
  )
}

export const getErrorMessageFromTab = (error: AxiosError) => {
  const errorDetails = get(error, "response.data.detail[0].msg", null)
  return typeof errorDetails === "string"
    ? errorDetails
    : "validations.anErrorOccured"
}

export const getErrorMessageWithFallback = (
  error: AxiosError,
  fallbackKey: string
) => {
  const errorDetail = get(error, "response.data.detail", null)

  if (Array.isArray(errorDetail)) {
    return getErrorMessageFromTab(error)
  }

  return typeof errorDetail === "string" ? errorDetail : fallbackKey
}

export const parseJwt = (token: string) => {
  if (!token || typeof token !== "string") {
    throw new Error("Invalid token provided to parseJwt")
  }

  const parts = token.split(".")
  if (parts.length !== 3) {
    throw new Error("Invalid JWT token format")
  }

  const base64Url = parts[1]
  if (!base64Url) {
    throw new Error("Invalid JWT token structure")
  }

  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  return JSON.parse(jsonPayload)
}

const activeProStatuses = new Set<Subscription_Status>([
  Subscription_Status.ACTIVE,
  Subscription_Status.PAST_DUE,
  Subscription_Status.TRIALING,
])

export const checkSubscription = (user: IUserMe | null) => {
  let userT: IUserTeacher | null = null
  let userS: IUserMe | null = null
  if (user !== null) {
    userT = user.user as IUserTeacher
    userS = user
  }
  if (userS?.type === "student") return true

  if (userT?.school_plan === UserSchoolPlan.FREE) return true
  if (userT?.school_plan === UserSchoolPlan.DEMO) return true
  if (userT?.school_plan === UserSchoolPlan.SCHOOL) return true

  if (
    userT &&
    userT.school_plan === UserSchoolPlan.PRO &&
    activeProStatuses.has(userT.subscription_status)
  )
    return true

  return false
}
